<template>
  <section>
    <NewList class="new-list" :board_id="board_id"/>
    <div class="lists">
      <section v-for="list in lists" :key="list.list_id">
        <List :list="list" @deleteList="deleteAList" @insertIntoDifferentList="manageListItem"/>
        <!-- <List
          :id="list.list_id"
          :list="list"
          @deleteList="deleteAList"
          @insertIntoDifferentList="manageListItem"
        />-->
      </section>
    </div>
  </section>
</template>

<script>
import db from "@/fb/init";
import firebase from "firebase/app";

import { EventBus } from "@/eventbus";

import NewList from "@/components/NewList";
import List from "@/components/List";

export default {
  name: "Lists",
  components: { List, NewList },
  props: ["board_id"],
  data() {
    return {
      lists: []
    };
  },
  methods: {
    manageListItem(newListId) {
      // protect against undefined
      if (newListId) {
        const originalItem = JSON.parse(window.localStorage.getItem("item"));
        const newItem = Object.assign({}, originalItem);
        newItem.list_id = newListId;
        this.updateItemsDb(newItem, originalItem, "union");
      }
    },

    removeFromList(item) {
      this.updateItemsDb(item, null, "remove");
    },

    updateItemsDb(item, originalItem, flag) {
      EventBus.$emit("clearFlash");
      // use flag to either remove or add to db
      const callbackFn =
        flag === "union"
          ? firebase.firestore.FieldValue.arrayUnion(item)
          : firebase.firestore.FieldValue.arrayRemove(item);
      db.collection("boards")
        .doc(item.board_id)
        .collection("lists")
        .doc(item.list_id)
        .update({
          items: callbackFn
        })
        .then(() => {
          if (originalItem) this.removeFromList(originalItem);
        })
        .catch(err => {
          const messageObj = {
            message: err.message,
            status: "error",
            duration: 3000
          };
          EventBus.$emit("showFlash", messageObj);
        });
    },

    deleteAList(list) {
      db.collection("boards")
        .doc(list.board_id)
        .collection("lists")
        .doc(list.list_id)
        .delete()
        .catch(err => window.console.log(err.message));
    }
  },
  mounted() {
    db.collection("boards")
      .doc(this.board_id)
      .collection("lists")
      .orderBy("name")
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === "added") {
            this.lists.push({ ...change.doc.data() });
          }
          if (change.type === "modified") {
            this.lists.forEach(l => {
              if (l.list_id === change.doc.id) {
                l = change.doc.data();
              }
            });
          }
          if (change.type === "removed") {
            this.lists = this.lists.filter(l => l.list_id !== change.doc.id);
          }
        });
      });

    EventBus.$on("createList", list => {
      EventBus.$emit("clearFlash");

      db.collection("boards")
        .doc(list.board_id)
        .collection("lists")
        .doc(list.list_id)
        .set(list)
        .catch(err => {
          window.console.log(err);
          const messageObj = {
            message: err.message,
            status: "error",
            duration: 3000
          };
          EventBus.$emit("showFlash", messageObj);
        });
    });
  }
};
</script>
